import { render, staticRenderFns } from "./EditPostOverview.vue?vue&type=template&id=fd2124f4&scoped=true&"
import script from "./EditPostOverview.vue?vue&type=script&lang=ts&"
export * from "./EditPostOverview.vue?vue&type=script&lang=ts&"
import style0 from "./EditPostOverview.vue?vue&type=style&index=0&id=fd2124f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2124f4",
  null
  
)

export default component.exports